//CORE
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import {HttpClient, HttpHeaders} from '@angular/common/http';

//OBSERVABLE
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

//MODEL
import {LessonInfo} from '../model/lessonInfo';
import {Topbar} from '../model/topbar';
import {userCredentials} from '../model/user_credentials';

import {environment} from '../../environments/environment';
import {Language} from "../model/language";


@Injectable()
export class AppService {

  constructor(private http: Http, private httpc: HttpClient) {
    this.http = http;
  }

  Login(user: userCredentials): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    headers.append('Access-Control-Allow-Origin', '*');
    const options = new RequestOptions({headers: headers});
    return this.http.post(environment.base_url + 'Login_Controller/login',
      'email=' + user.email + '&password=' + user.password, options)
      .map((response: Response) => response.json())
      .catch((error: any) => {
        return Observable.throw(error || error.json().error || 'Backend Server Error');
      });
  }

  LoginUrl(data: string): Observable<Topbar> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*',
        'X-API-KEY': '8Fzc8^aXZ*Sc44%8'
      })
    };

    return this.httpc.post(environment.base_url + 'Login_Controller/login', data, httpOptions)
      .catch((error: any) => {
        return Observable.throw(error || error.json().error || 'Backend Server Error');
      });
  }

  TestLoginUrl(data: string): Observable<Topbar> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Access-Control-Allow-Origin': '*'
      })
    };

    return this.httpc.post(environment.base_url + 'Test_Login_Controller/login', data, httpOptions)
      .catch((error: any) => {
        return Observable.throw(error || error.json().error || 'Backend Server Error');
      });
  }

  getHeader(user_id: number, key: string): Observable<Topbar[]> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('X-API-KEY', key);
    const options = new RequestOptions({headers: headers});
    return this.http.get(environment.base_url + 'Rest_User/user/id/' + user_id + '/', options)
      .map((response: Response) => <Topbar[]>response.json())
      .catch((error: any) => {
        return Observable.throw(error || error.json().error || 'Backend Server Error');
      });
  }

  getCurrentLessonId(course_id: number, user_id: number, key: string): Observable<LessonInfo> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    headers.append('X-API-KEY', key);
    const options = new RequestOptions({headers: headers});
    return this.http.get(environment.base_url + 'Rest_Single_Lesson/current_lesson_id/id_course/' + course_id + '/user_id/' + user_id, options)
      .map((response: Response) => <LessonInfo>response.json())
      .catch((error: any) => {
        return Observable.throw(error || error.json().error || 'Backend Server Error');
      });
  }

  getAllLanguages(): Observable<Language[]> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    const options = new RequestOptions({headers: headers});
    return this.http.get(environment.base_url + 'Rest_Language/all_languages', options)
      .map((response: Response) => <Language[]>response.json())
      .catch((error: any) => {
        return Observable.throw(error || error.json().error || 'Backend Server Error');
      });
  }

  loadJSON(fileUrl): Observable<any> {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Access-Control-Allow-Origin', '*');
    const options = new RequestOptions({headers: headers});
    return this.http.get(fileUrl, options)
      .map((response: Response) => <Language[]>response.json())
      .catch((error: any) => {
        return Observable.throw(error);
      });
  }
}






// WEBPACK FOOTER //
// ./src/app/services/app.service.ts